import { DateObject } from 'react-multi-date-picker'
import {
  LocalDatetimeToUtcIso,
  UtcIsoToBelgianDatetimeLocalInput,
} from '@onclicks/sharedmobilecommon/utils/LocaleDatetimeToUtcIso'

/**
 * Passerelle entre les sélecteurs web et les helpers de l'app mobile : la date affichée dans le
 * picker est toujours l'heure de Bruxelles, quel que soit le fuseau de l'appareil, et le back
 * reçoit l'instant UTC correspondant (même conversion que `kms7-mobile`).
 */

/** Heure murale choisie dans le picker → instant ISO UTC. */
export const pickerDateToUtcIso = (date: DateObject): string =>
  LocalDatetimeToUtcIso(date.format('YYYY-MM-DD HH:mm').replace(' ', 'T')) ?? ''

/** Instant ISO UTC → `DateObject` portant l'heure de Bruxelles, pour l'affichage dans le picker. */
export const utcIsoToPickerDate = (iso: string): DateObject => {
  // « yyyy-MM-ddTHH:mm » à l'heure de Bruxelles
  const [year = 0, month = 0, day = 0, hour = 0, minute = 0] = UtcIsoToBelgianDatetimeLocalInput(iso)
    .split(/[-T:]/)
    .map(Number)
  return new DateObject({ year, month, day, hour, minute })
}
